// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3_tJo","inputWrap":"CustomTip_inputWrap__3jAdm"};